import { defineStore } from "pinia";

export const useCollectStore = defineStore("CollectStore", {
    actions: {
        async trackVisitor(platform = "web") {
            const { $api } = useNuxtApp()
            try {
                const storedId = localStorage.getItem("mvuid");
                if (storedId) {
                    return;
                }

                const randomHex = Array.from(crypto.getRandomValues(new Uint8Array(8)))
                    .map((b) => b.toString(16).padStart(2, "0"))
                    .join("");
                const newId = `medium_uid_nuxt_${randomHex}`;

                await $api<any>("/collect", {
                    method: 'POST',
                    body: {
                        user: newId,
                        platform: platform,
                    }
                });
                localStorage.setItem("mvuid", newId);
            } catch (error) { }
        },
    },
});
